var React = require('react');
var ReactRouter = require('react-router');
var Link = ReactRouter.Link;
var ReactDOM = require('react-dom');

module.exports = React.createClass({
    
  componentDidUpdate: function() {
    jQuery(ReactDOM.findDOMNode(this.refs.catMenus)).find('a').on('click', function(e) {
        jQuery(e.target.parentNode).slideUp();
    });
  },

  toggleMenus: function() {
    jQuery(ReactDOM.findDOMNode(this.refs.catMenus)).slideToggle();
  },

  render: function() {
    var arrMenu = [<Link to={"/collections/" + this.props.gender}>Collections</Link>];
    var i = 0;

    var catMenus = _.reduce(this.props.menus, function(acc, menu) {
      i++;
      acc.push(<Link to={menu.url} key={(this.props.from ? this.props.from : "" ) + this.props.gender + i}>
                   {menu.title}
               </Link>);
      return acc;
    }.bind(this), arrMenu);

    return <nav ref="catMenus" id="cat-menu">
               {catMenus}
           </nav>
  }
})